"use client"

import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import { buildCuratedEarnVaults } from "./buildCuratedEarnVaults"
import { fetchEarnVaultSummary } from "./earnVaultSummary"

const EARN_VAULT_SUMMARY_QUERY_KEY = ["earn-vault-summary"] as const
const EARN_VAULT_SUMMARY_STALE_TIME = 5 * 60 * 1000
const EARN_VAULT_SUMMARY_GC_TIME = 30 * 60 * 1000

export function useCuratedEarnVaults(enabled = true) {
  const summaryQuery = useQuery({
    queryKey: EARN_VAULT_SUMMARY_QUERY_KEY,
    queryFn: fetchEarnVaultSummary,
    staleTime: EARN_VAULT_SUMMARY_STALE_TIME,
    gcTime: EARN_VAULT_SUMMARY_GC_TIME,
    retry: 2,
    enabled,
  })

  const vaults = useMemo(
    () =>
      enabled
        ? buildCuratedEarnVaults(summaryQuery.data?.vaultDataByAssetId ?? {})
        : [],
    [enabled, summaryQuery.data]
  )

  return { vaults, summaryQuery }
}
